import {
    ADD_ALERT,
    REMOVE_ALERT,
    UNAUTHENTICATED
} from "../actions/action-types"

export default (state = [], action) => {
    const { type, alertId, alertType, ...rest } = action
    switch (type) {
        case ADD_ALERT:
            return [
                {
                    id: alertId,
                    type: alertType,
                    ...rest
                },
                ...state
            ]
        case REMOVE_ALERT:
            return state.filter(({ id }) => id !== alertId)
        case UNAUTHENTICATED:
            return []
        default:
            return state
    }
}
